// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1S9OL","imageUploader":"EGiftCard_imageUploader__37DdE"};